export function getTimezones(): string[] {
  try {
    return Intl.supportedValuesOf("timeZone");
  } catch {
    return ["America/Chicago", "America/New_York", "America/Denver", "America/Los_Angeles", "UTC"];
  }
}
